import { useAppSelector } from '@/redux/hooks'
import {
  portalViews,
  findDesignIndex,
  findRefundMethodIndex,
  findRefundTimingIndex,
  findReturnMethodIndex
} from '@/ui/components/portal-preview'

export const languages = [
  { name: 'custom_copies.de', code: 'DE' },
  { name: 'custom_copies.en', code: 'EN' },
  { name: 'custom_copies.fr', code: 'FR' },
  { name: 'custom_copies.it', code: 'IT' },
  { name: 'custom_copies.pt', code: 'PT' },
  { name: 'custom_copies.es', code: 'ES' },
  { name: 'custom_copies.nl', code: 'NL' },
  { name: 'custom_copies.pl', code: 'PL' },
  { name: 'custom_copies.cs', code: 'CS' },
  { name: 'custom_copies.sk', code: 'SK' }
]

type Copy = {
  key: string
  text: string
  method: number
  description: number
}

type Page = {
  text: string
  key: keyof typeof portalViews
  copies: Copy[]
}

const editableCopies: Page[] = [
  {
    text: 'custom_copies.landing_page_title',
    key: 'landing' as keyof typeof portalViews,
    copies: [
      { key: 'landing_title', text: 'title', method: 0, description: 0 },
      {
        key: 'landing_title_layout2',
        text: 'title',
        method: 0,
        description: 0
      },
      {
        key: 'landing_title_layout_simplified',
        text: 'title',
        method: 0,
        description: 0
      },
      {
        key: 'landing_subtitle',
        text: 'subtitle',
        method: 0,
        description: 0
      }
    ]
  },
  {
    text: 'custom_copies.refund_methods_page_title',
    key: 'refundMethods' as keyof typeof portalViews,
    copies: [
      {
        method: 1,
        description: 0,
        key: 'refund_card_method1_title',
        text: 'bank_transfer_title'
      },
      {
        method: 1,
        description: 1,
        key: 'refund_card_method1_description1',
        text: 'bank_transfer_description'
      },
      {
        method: 1,
        description: 2,
        key: 'refund_card_method1_description2',
        text: 'bank_transfer_description'
      },
      {
        method: 1,
        description: 3,
        key: 'refund_card_method1_description3',
        text: 'bank_transfer_description'
      },
      {
        method: 1,
        description: 4,
        key: 'refund_card_method1_description4',
        text: 'bank_transfer_description'
      },
      {
        method: 2,
        description: 0,
        key: 'refund_card_method2_title',
        text: 'original_payment_method_title'
      },
      {
        method: 2,
        description: 1,
        key: 'refund_card_method2_description1',
        text: 'original_payment_method_description'
      },
      {
        method: 2,
        description: 2,
        key: 'refund_card_method2_description2',
        text: 'original_payment_method_description'
      },
      {
        method: 2,
        description: 3,
        key: 'refund_card_method2_description3',
        text: 'original_payment_method_description'
      },
      {
        method: 3,
        description: 0,
        key: 'refund_card_method3_title',
        text: 'gift_card_title'
      },
      {
        method: 3,
        description: 1,
        key: 'refund_card_method3_description1',
        text: 'gift_card_description'
      },
      {
        method: 3,
        description: 2,
        key: 'refund_card_method3_description2',
        text: 'gift_card_description'
      },
      {
        method: 3,
        description: 3,
        key: 'refund_card_method3_description3',
        text: 'gift_card_description'
      },
      {
        method: 4,
        description: 0,
        key: 'refund_card_method4_title',
        text: 'gift_card_title'
      },
      {
        method: 4,
        description: 1,
        key: 'refund_card_method4_description1',
        text: 'gift_card_description'
      },
      {
        method: 4,
        description: 2,
        key: 'refund_card_method4_description2',
        text: 'gift_card_description'
      },
      {
        method: 4,
        description: 3,
        key: 'refund_card_method4_description3',
        text: 'gift_card_description'
      }
    ]
  },
  {
    text: 'custom_copies.return_methods_page_title',
    key: 'returnMethods' as keyof typeof portalViews,
    copies: [
      {
        key: 'return_card_method2_title',
        text: 'drop_off_title',
        method: 2,
        description: 0
      },
      {
        key: 'return_card_method2_description',
        text: 'drop_off_description',
        method: 2,
        description: 0
      },
      {
        key: 'return_card_dropoff_link',
        text: 'drop_off_button',
        method: 2,
        description: 0
      },
      {
        key: 'return_card_method1_title',
        text: 'home_pickup_title',
        method: 1,
        description: 0
      },
      {
        key: 'return_card_method1_description',
        text: 'home_pickup_description',
        method: 1,
        description: 0
      },
      {
        key: 'return_card_method3_title',
        text: 'delivery_and_home_pickup_title',
        method: 3,
        description: 0
      },
      {
        key: 'return_card_method3_description',
        text: 'delivery_and_home_pickup_description',
        method: 3,
        description: 0
      },
      {
        key: 'return_card_method4_title',
        text: 'in_store_title',
        method: 4,
        description: 0
      },
      {
        key: 'return_card_method4_description',
        text: 'in_store_description',
        method: 4,
        description: 0
      },
      {
        key: 'return_card_in_store_link',
        text: 'in_store_button',
        method: 4,
        description: 0
      }
    ]
  }
]

export function useEditableCopies() {
  const editableCopiesData: Page[] = [
    { key: 'landing', text: '', copies: [] },
    { key: 'refundMethods', text: '', copies: [] },
    { key: 'returnMethods', text: '', copies: [] }
  ]
  editableCopies.forEach((copy, index) => {
    editableCopiesData[index].text = copy.text
  })

  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )
  const design = settings.theme?.design ?? 'DEFAULT'
  const designIndex = findDesignIndex(design)

  editableCopiesData[0].copies = [
    editableCopies[0].copies[designIndex],
    editableCopies[0].copies[3]
  ]

  const refundMethods = useAppSelector(
    (store) =>
      store.settingsApi.settings.response.refund?.payment_method_configs
  )
  const refundMethodsCopies = refundMethods?.map((method) => {
    return [
      findRefundMethodIndex(method.name ?? ''),
      findRefundTimingIndex(method.timing ?? '')
    ]
  })
  editableCopiesData[1].copies = editableCopies[1].copies.filter((copy) => {
    const copyMethod = refundMethodsCopies?.find(
      (method) =>
        method[0] === copy.method &&
        (method[1] === copy.description || copy.description === 0)
    )
    return copyMethod !== undefined
  })

  const settingsReturnMethods = useAppSelector(
    (store) => store.settingsApi.settings.response.return_logistics
  )
  const returnMethods = [
    ...new Set(settingsReturnMethods?.map((rm) => rm.return_method))
  ]
  const returnMethodsCopies = returnMethods?.map((method) => {
    return findReturnMethodIndex(method ?? '')
  })
  editableCopiesData[2].copies = editableCopies[2].copies.filter((copy) => {
    const copyMethod = returnMethodsCopies?.find(
      (method) => method === copy.method
    )
    return copyMethod !== undefined
  })
  return editableCopiesData
}
